import React from 'react';
import { Alert, Checkbox, Col, Empty, Input, Row, Select } from 'antd';
import { StyledContainer, StyledStockTable, SummaryCard, SummaryRow } from './styles';
import { CardTheme, TextLarge, TextSmall, ResponsivePageLayout } from '../../../components';
import ButtonExcelEmbedded from '../../../components/report-excel/ButtonExcelEmbedded';
import { ContainerButton } from '../../../styles/global-style';
import { SpaceBetween } from '../../manage-data/user-info/styles';
import { Icon } from '../../../resources';
import { ButtonTheme } from '../../../components/buttons';
import { stockClaimColumns } from './columns';
import { STOCK_STATUS_OPTIONS } from './resource/stockStatus';
import { useGetStockClaimReport } from './hooks/useGetStockClaimReport';
import { useStockClaimFilters } from './hooks/useStockClaimFilters';

const EXPORT_HEADER = [
  { title: 'รหัสสินค้า', dataIndex: 'itemId' },
  { title: 'ชื่อสินค้า', dataIndex: 'itemName' },
  { title: 'รุ่นมือถือ', dataIndex: 'mobileModelDisplay' },
  { title: 'บริษัท', dataIndex: 'company' },
  { title: 'คงเหลือ', dataIndex: 'availableQty' },
  { title: 'รอส่ง CS', dataIndex: 'pendingQty' },
  { title: 'คงเหลือสุทธิ', dataIndex: 'netAvailableQty' },
  { title: 'จองโดยเคลม', dataIndex: 'reservedQtyDisplay' },
  { title: 'ใช้ได้จริง', dataIndex: 'effectiveAvailableQty' },
  { title: 'อัปเดตล่าสุด', dataIndex: 'updatedAt' },
];

export const ReportStockClaim = () => {
  const { items, loading, isError, errorMessage, onRefresh } = useGetStockClaimReport();
  const {
    keyword,
    setKeyword,
    mobileModel,
    setMobileModel,
    stockStatus,
    setStockStatus,
    reservedOnly,
    setReservedOnly,
    mobileModelOptions,
    filteredRows,
    summary,
    formatDataForExcel,
  } = useStockClaimFilters(items);

  const columns = stockClaimColumns();

  return (
    <StyledContainer>
      <TextLarge text="รายงาน stock เคลม" />
      <CardTheme>
        <StyledStockTable>
          <ResponsivePageLayout
            content={
              <>
                <Row gutter={[12, 12]} align="middle">
                  <Col xs={24} md={7}>
                    <Input
                      allowClear
                      placeholder="ค้นหารหัสสินค้า หรือ ชื่อสินค้า"
                      value={keyword}
                      onChange={(e) => setKeyword(e.target.value)}
                    />
                  </Col>
                  <Col xs={24} md={5}>
                    <Select
                      style={{ width: '100%' }}
                      value={mobileModel}
                      options={mobileModelOptions}
                      onChange={setMobileModel}
                      placeholder="รุ่นมือถือ"
                    />
                  </Col>
                  <Col xs={24} md={5}>
                    <Select
                      style={{ width: '100%' }}
                      value={stockStatus}
                      options={STOCK_STATUS_OPTIONS}
                      onChange={setStockStatus}
                      placeholder="สถานะสต็อก"
                    />
                  </Col>
                  <Col xs={24} md={4}>
                    <Checkbox
                      checked={reservedOnly}
                      onChange={(e) => setReservedOnly(e.target.checked)}
                    >
                      มีการจองจากเคลม
                    </Checkbox>
                  </Col>
                  <Col xs={24} md={3}>
                    <ButtonTheme
                      useFor="REFRESH"
                      title="รีเฟรช"
                      icon={<Icon.reAct />}
                      type="default"
                      loading={loading}
                      onClick={onRefresh}
                    />
                  </Col>
                </Row>
                {isError && (
                  <Alert style={{ marginTop: 12 }} type="error" showIcon message={errorMessage} />
                )}
                <SummaryRow style={{ marginTop: 16 }}>
                  <SummaryCard>
                    <TextSmall bold>จำนวนรายการที่แสดง</TextSmall>
                    <TextLarge text={`${summary.rowCount.toLocaleString('th-TH')} รายการ`} />
                  </SummaryCard>
                  <SummaryCard>
                    <TextSmall bold>สินค้าใช้ได้จริง ≤ 0</TextSmall>
                    <TextLarge text={`${summary.shortItemCount.toLocaleString('th-TH')} รายการ`} />
                  </SummaryCard>
                  <SummaryCard>
                    <TextSmall bold>จองโดยเคลมรวม (นับครั้งเดียวต่อสินค้า)</TextSmall>
                    <TextLarge text={`${summary.totalReserved.toLocaleString('th-TH')} ชิ้น`} />
                  </SummaryCard>
                </SummaryRow>
                {!loading && !isError && items.length === 0 && (
                  <Empty description="ไม่พบข้อมูลสต็อก" style={{ margin: '24px 0' }} />
                )}
              </>
            }
            tableLayout={{
              columns,
              dataSource: filteredRows,
              hasPagination: true,
              loading,
              rowKey: (record, index) => `${record?.itemId}-${index}`,
              rowClassName: (record) =>
                record?.effectiveAvailableQty < 0 ? 'stock-claim-row-danger' : '',
              extraContent: (
                <SpaceBetween>
                  <div />
                  <ContainerButton right>
                    <ButtonExcelEmbedded
                      title="Export"
                      filename="รายงาน-stock-เคลม"
                      header={EXPORT_HEADER}
                      data={formatDataForExcel(filteredRows)}
                    />
                  </ContainerButton>
                </SpaceBetween>
              ),
            }}
          />
        </StyledStockTable>
      </CardTheme>
    </StyledContainer>
  );
};
